export default "__VITE_ASSET__CA96icXU__"